module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-Thin.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-Thin.eot
// module id = 9
// module chunks = 8